/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  DataEnvelopeOfOperationalHealthDto,
  DataEnvelopeOfOperationalWorkPageDto,
  ErrorEnvelope,
  GetOperationalWorkItemsParams,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * @summary Consulta pendências operacionais da organização, sem dados privados de envio
 */
export const getOperationalWorkItems = (
  params?: GetOperationalWorkItemsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfOperationalWorkPageDto>(
    { url: `/v1/operations/work-items`, method: 'GET', params, signal },
    options,
  )
}

export const getGetOperationalWorkItemsQueryKey = (params?: GetOperationalWorkItemsParams) => {
  return [`/v1/operations/work-items`, ...(params ? [params] : [])] as const
}

export const getGetOperationalWorkItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOperationalWorkItems>>,
  TError = ErrorEnvelope,
>(
  params?: GetOperationalWorkItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOperationalWorkItems>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOperationalWorkItemsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOperationalWorkItems>>> = ({
    signal,
  }) => getOperationalWorkItems(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOperationalWorkItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOperationalWorkItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOperationalWorkItems>>
>
export type GetOperationalWorkItemsQueryError = ErrorEnvelope

export function useGetOperationalWorkItems<
  TData = Awaited<ReturnType<typeof getOperationalWorkItems>>,
  TError = ErrorEnvelope,
>(
  params: undefined | GetOperationalWorkItemsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOperationalWorkItems>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOperationalWorkItems>>,
          TError,
          Awaited<ReturnType<typeof getOperationalWorkItems>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOperationalWorkItems<
  TData = Awaited<ReturnType<typeof getOperationalWorkItems>>,
  TError = ErrorEnvelope,
>(
  params?: GetOperationalWorkItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOperationalWorkItems>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOperationalWorkItems>>,
          TError,
          Awaited<ReturnType<typeof getOperationalWorkItems>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOperationalWorkItems<
  TData = Awaited<ReturnType<typeof getOperationalWorkItems>>,
  TError = ErrorEnvelope,
>(
  params?: GetOperationalWorkItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOperationalWorkItems>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Consulta pendências operacionais da organização, sem dados privados de envio
 */

export function useGetOperationalWorkItems<
  TData = Awaited<ReturnType<typeof getOperationalWorkItems>>,
  TError = ErrorEnvelope,
>(
  params?: GetOperationalWorkItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOperationalWorkItems>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOperationalWorkItemsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Consulta disponibilidade e execução dos jobs conhecidos, sem configuração privada
 */
export const getOperationalHealth = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfOperationalHealthDto>(
    { url: `/v1/operations/health`, method: 'GET', signal },
    options,
  )
}

export const getGetOperationalHealthQueryKey = () => {
  return [`/v1/operations/health`] as const
}

export const getGetOperationalHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getOperationalHealth>>,
  TError = ErrorEnvelope,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOperationalHealth>>, TError, TData>>
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOperationalHealthQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOperationalHealth>>> = ({ signal }) =>
    getOperationalHealth(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOperationalHealth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOperationalHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOperationalHealth>>
>
export type GetOperationalHealthQueryError = ErrorEnvelope

export function useGetOperationalHealth<
  TData = Awaited<ReturnType<typeof getOperationalHealth>>,
  TError = ErrorEnvelope,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOperationalHealth>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOperationalHealth>>,
          TError,
          Awaited<ReturnType<typeof getOperationalHealth>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOperationalHealth<
  TData = Awaited<ReturnType<typeof getOperationalHealth>>,
  TError = ErrorEnvelope,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOperationalHealth>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOperationalHealth>>,
          TError,
          Awaited<ReturnType<typeof getOperationalHealth>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOperationalHealth<
  TData = Awaited<ReturnType<typeof getOperationalHealth>>,
  TError = ErrorEnvelope,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOperationalHealth>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Consulta disponibilidade e execução dos jobs conhecidos, sem configuração privada
 */

export function useGetOperationalHealth<
  TData = Awaited<ReturnType<typeof getOperationalHealth>>,
  TError = ErrorEnvelope,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOperationalHealth>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOperationalHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
